import { useState, useEffect } from 'react';

/**
 * true por debajo de 768px (breakpoint `md` de Tailwind). Sin dependencia nueva --
 * usa matchMedia nativo, igual de confiable que una libreria y sin agregar peso al bundle.
 */
export default function useIsMobile(breakpoint = 767) {
  const query = `(max-width: ${breakpoint}px)`;
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  ));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
